export default function getDomain() {
    if (process.env.REACT_APP_DOMAIN_BASE === "") {
        return window.location.origin;
    }
    return process.env.REACT_APP_DOMAIN_BASE;
}
